import ftdImage1 from "@images/klein-telefonieren-sie-mit-einem-laptop.jpeg";
import ftdImage2 from "@images/ausdrucksstarke-huebsche-frau-posiert.jpeg";
import ftdImage3 from "@images/digital-increasing-bar-graph-with-businessman-hand-overlay.jpeg";

export const ftdNewsFeedData = [
  {
    title: "Top-Tarife der Woche: Tagesgeld, Festgeld, Online-Kredit und Handy",
    link: "https://www.ftd.de/finanzen/finanzcheck/top-tarife-der-woche-tagesgeld-festgeld-online-kredit-und-handy/",
    imageURL: ftdImage1,
    showItemType: false,
    openInNewPage: true,
  },
  {
    title:
      "Haushaltsbuch führen: wirksam Ausgaben senken und Geld sparen – so funktioniert es",
    link: "https://www.ftd.de/finanzen/finanzcheck/haushaltsbuch-fuehren-wirksam-ausgaben-senken-und-geld-sparen-so-funktioniert-es/",
    imageURL: ftdImage2,
    showItemType: false,
    openInNewPage: true,
  },
  {
    title: "Welche Anlagestrategie ist die beste für mich?",
    link: "https://www.ftd.de/finanzen/finanzcheck/welche-anlagestrategie-ist-die-beste-fuer-mich/",
    imageURL: ftdImage3,
    showItemType: false,
    openInNewPage: true,
  },
];
